import * as helpers from '../helpers';

const $ = helpers.$;

export default class ScrollAnimation {
	constructor($element, options) {
		this.$element = $element;
		this.type = options.type;
		this.duration = 1000;
		this.chooseHandler();		
	}

	chooseHandler() {
		const { $element } = this;

		if (this.type == 'page-nav') {
			this.handlePageNav();

		} else if (this.type == 'site-nav') {
			this.handleSiteNav();
			this.handlePageLoad();

		} else {
			console.log("ScrollAnimation: invalid type - please supply 'type:page-nav' or 'type:site-nav' in data-options.")
		}
	}	

	handlePageNav() {
		const _this = this;

		_this.$element.find('a').click(function(e) {
			e.preventDefault();

			const href = $(this).attr('href'),
				targetOffset = helpers.getTargetOffset(href);

			console.log(targetOffset);

			helpers.executeScroll(targetOffset - 100, _this.duration);
		});
	}

	handleSiteNav() {
		const _this = this,
			$nav = this.$element;

		$nav.find('a').click(function(e) {
			const targetHref = $(this).attr('href'),
				windowLocation = helpers.stripHash(window.location.href),
				targetUrlNoHash = helpers.stripHash(targetHref),
				targetHash = helpers.getHash(targetHref);

			// when clicked link leads to anchor within same page
			if (targetHash && windowLocation == targetUrlNoHash) {
				e.preventDefault();
				const targetOffset = helpers.getTargetOffset(targetHash)
				helpers.executeScroll(targetOffset - 100, _this.duration);
			}
		});
	}

	handlePageLoad() {
		const duration = this.duration,
			hash = helpers.getHash(window.location.href);

		if (hash) {
			window.location.hash = '';
			$(document).ready(function() {
				const targetOffset = helpers.getTargetOffset(hash);
				helpers.executeScroll(targetOffset - 100, duration);
			});
		}
	}
}



// WEBPACK FOOTER //
// ./assets/js/src/components/ScrollAnimation.js